Vue.component('accountOrderFind', {
    data() {
        return {
            root: this.$root,
            datepicker: null,
            searching : false
        };
    },
    mounted() {

        Vue.nextTick(() => {

            this.initDatePicker();

        });
    },
    watch: {
    },
    methods: {

        initDatePicker() {
            this.datepicker = flatpickr(document.querySelector('.js-datepicker'),
                {
                    locale: document.documentElement.lang.split('-')[0],
                    altInput: true,
                    altFormat: 'j F Y',
                    //inline: true,
                    enableTime: false,
                    //minDate: 'today',
                    time_24hr: true,
                    //defaultDate: this.OrderDate,
                    onMonthChange: (selectedDates, dateStr, instance) => {

                    },
                    onYearChange: (selectedDates, dateStr, instance) => {

                    },
                    onChange: (selectedDates, dateStr, instance) => {

                        //this.OrderDate = dateStr;
                    },
                });

        },
        submitOrder(e) {

            this.searching = true;

            this.submitForm(e.target);
        },
        submitForm(form) {

            var orderDate = document.getElementById('OrderDate').value;

            if (form.checkValidity() && orderDate !== "") {

                if (form.querySelector('.g-recaptcha') !== null) {
                    grecaptcha.reset();
                    grecaptcha.execute();

                    this.searching = false;

                    return false;
                } else {

                    form.submit();
                    return true;
                }
            }

            this.searching = false;

            return false;
        },

    },
});